/**
 * One share dialog for the whole app: the message toolbar and the sidebar
 * row menu both just set a target here, the singleton ``<ShareLinkDialog>``
 * mounted in the route shell reads it. Kept as a leaf module (no barrel
 * imports) so ``features/chat`` can open it without a dependency cycle.
 */

import type { ChatShareTarget } from "@ando/core";
import { create } from "zustand";

interface ShareDialogState {
  target: ChatShareTarget | null;
  open: (target: ChatShareTarget) => void;
  close: () => void;
}

export const useShareDialogStore = create<ShareDialogState>()((set) => ({
  target: null,
  open: (target) => set({ target }),
  close: () => set({ target: null }),
}));
